import { useEffect, useRef } from 'react'

import { GetRef, InputNumber } from 'antd'
import { useTheme } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useTableContextMenuStore } from '../Store/hooks/useStore'

import { RowCountInputProps } from './interface'

export const RowCountInput = ({
  countKey: rowCountKey
}: RowCountInputProps) => {
  const ref = useRef<GetRef<typeof InputNumber>>(null)
  const { prefixCls } = useTheme()

  // 防止点击 InputNumber 时触发 ContextMenu 的关闭逻辑
  useEffect(() => {
    let parentDom: HTMLElement | null = null
    const clickListener = (event: MouseEvent) => event.stopPropagation()
    if (ref.current) {
      parentDom = ref.current.closest(`.${prefixCls}-input-number`)
      if (parentDom) {
        parentDom.addEventListener('click', clickListener)
      }
    }
    return () => {
      if (parentDom) {
        parentDom.removeEventListener('click', clickListener)
      }
    }
  }, [prefixCls])

  const state = useTableContextMenuStore(state =>
    pick(state, [rowCountKey, 'setRowColCount'])
  )

  return (
    <InputNumber
      ref={ref}
      size='small'
      value={state[rowCountKey]}
      onChange={value => state.setRowColCount({ [rowCountKey]: value })}
    />
  )
}
